<div class="customers-wrapper">
  <!-- <div class="customers-header">
    <h1>Ügyfelek</h1>
  </div> -->
  
  <div class="customers-content">
    <!-- Keresés és szűrés -->
    <app-shared-filters 
      [pageName]="'customers'"
      [initialFilter]="initialFilter"
      [showOnlySearch]="true"
      (filterChange)="onFilterChange($event)"
      (clearFilters)="onClearFilters()">
    </app-shared-filters>
    
    <app-customers-table></app-customers-table>
  </div>
</div>